import { render } from "./organization_info.vue?vue&type=template&id=a5061438&scoped=true"
import script from "./organization_info.vue?vue&type=script&lang=js"
export * from "./organization_info.vue?vue&type=script&lang=js"

import "./organization_info.vue?vue&type=style&index=0&id=a5061438&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5061438"]])

export default __exports__